var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.25V0H0.75C0.3125 0 0 0.34375 0 0.75V15.25C0 15.6875 0.3125 16 0.75 16H11.25C11.6562 16 12 15.6875 12 15.25V5H7.75C7.3125 5 7 4.6875 7 4.25ZM9 11.625C9 11.8438 8.8125 12 8.625 12H3.375C3.15625 12 3 11.8438 3 11.625V11.375C3 11.1875 3.15625 11 3.375 11H8.625C8.8125 11 9 11.1875 9 11.375V11.625ZM9 9.625C9 9.84375 8.8125 10 8.625 10H3.375C3.15625 10 3 9.84375 3 9.625V9.375C3 9.1875 3.15625 9 3.375 9H8.625C8.8125 9 9 9.1875 9 9.375V9.625ZM9 7.375V7.625C9 7.84375 8.8125 8 8.625 8H3.375C3.15625 8 3 7.84375 3 7.625V7.375C3 7.1875 3.15625 7 3.375 7H8.625C8.8125 7 9 7.1875 9 7.375ZM12 3.8125C12 3.625 11.9062 3.4375 11.7812 3.28125L8.71875 0.21875C8.5625 0.09375 8.375 0 8.1875 0H8V4H12V3.8125Z",
    fill: "#F82551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf_icon.6d90df81383d258728a43ac4e2eb7f89.svg";
export { ForwardRef as ReactComponent };